/* eslint-disable react/jsx-key */

import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const ShoppingCartActiveIcon = createIcon({
  displayName: 'CartIcon',
  viewBox: '0 0 24 24',
  path: [
    <path
      d="M17.5 20.75C17.5 21.4404 16.9404 22 16.25 22C15.5596 22 15 21.4404 15 20.75C15 20.0596 15.5596 19.5 16.25 19.5C16.9404 19.5 17.5 20.0596 17.5 20.75Z"
      fill="inherit"
      stroke="inherit"
    />,
    <path
      d="M9.5 20.75C9.5 21.4404 8.94036 22 8.25 22C7.55964 22 7 21.4404 7 20.75C7 20.0596 7.55964 19.5 8.25 19.5C8.94036 19.5 9.5 20.0596 9.5 20.75Z"
      fill="inherit"
      stroke="inherit"
    />,
    <path
      d="M5.33834 3.98068L5.33841 3.98069L5.33896 3.97219C5.36733 3.53252 5.22482 3.09755 4.91924 2.76287L4.91933 2.76278L4.91168 2.75476C4.61093 2.43969 4.19177 2.25 3.74 2.25H2C1.86614 2.25 1.75 2.13386 1.75 2C1.75 1.86614 1.86614 1.75 2 1.75H3.74C4.31521 1.75 4.88255 1.99766 5.29089 2.42739C5.53653 2.70687 5.6996 3.04635 5.78243 3.41081L5.87089 3.8H6.27H18.56C20.0416 3.8 21.1599 4.9953 21.0513 6.47338L21.0513 6.47438C21.0403 6.62815 20.9123 6.75 20.75 6.75H5.44C5.25356 6.75 5.12382 6.60139 5.1382 6.4324L5.13834 6.43068L5.33834 3.98068Z"
      fill="inherit"
      stroke="inherit"
    />,
    <path
      d="M20.5101 8.75H5.17005C4.75005 8.75 4.41005 9.07 4.37005 9.48L4.01005 13.83C3.87005 15.54 5.21005 17 6.92005 17H18.0401C19.5401 17 20.8601 15.77 20.9701 14.27L21.3001 9.6C21.3401 9.14 20.9801 8.75 20.5101 8.75Z"
      fill="inherit"
    />,
  ],
});
